/**
 * scrollLock.js — one shared page-scroll lock for the lockout gates (2026-10-19).
 *
 * Each gate used to save `document.documentElement.style.overflow`, set 'hidden', and put the saved
 * value back when it closed. With several gates opening and closing in turn, a gate could save
 * ANOTHER gate's 'hidden' and restore it after everything had closed, leaving the outline unable to
 * scroll until a reload (Matt). A counter fixes it: the page scrolls again when the last lock is
 * released, whatever the order.
 *
 * Usage (in an effect): `return lockScroll()` — returns the release function.
 */
let count = 0
export function lockScroll() {
  count++
  document.documentElement.style.overflow = 'hidden'
  let released = false
  return function release() {
    if (released) return
    released = true
    count = Math.max(0, count - 1)
    if (count === 0) document.documentElement.style.overflow = ''
  }
}
